/**
 * 起始-结束小时时间分钟选择组件
 * 2018-1-2
 * Bai.Zhiming
 */
"use strict";
angular.module("trsStartEndTimeModule", []).
directive("trsStartEndTime", ["$templateRequest", "$timeout", "$q", "$compile", function($templateRequest, $timeout, $q, $compile) {
    return {
        restrict: "EA",
        transclude: false,
        require: 'ngModel',
        scope: {
            model: "=ngModel",
            placeholder: "@"
        },
        link: function(scope, $elem, $attrs) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {};
                scope.data = {};
                $elem.hide();
                initTemplate().then(function() {
                    initFocusHover();
                });
                scope.$watch("status.startTime", function(newV, oldV) {
                    bindValue(newV);
                });
                scope.$watch("status.endTime", function(newV, oldV) {
                    bindValue(newV);
                });
                scope.$watch("model", function(newV,oldV) {
                    if(!newV){
                        delete scope.status.endTime;
                        delete scope.status.startTime;
                    }
                });
                scope.placeholder = $attrs.placeholder;
            }
            /**
             * [bindValue description] 绑定赋值
             * @return {[type]} [description]
             */
            function bindValue(newV) {
                if (!newV) {
                    delete scope.status.endTime;
                } else {
                    if (scope.status.startTime > scope.status.endTime) {
                        var tempTime = scope.status.startTime;
                        scope.status.startTime = scope.status.endTime;
                        scope.status.endTime = tempTime;
                    }
                    var startHour = angular.isDate(scope.status.startTime) ? scope.status.startTime.getHours() : "";
                    var startMinute = angular.isDate(scope.status.startTime) ? scope.status.startTime.getMinutes() : "";
                    var startTime = angular.isDefined(startHour) ? handleNumber(startHour) + ":" + handleNumber(startMinute) : "";
                    var endHour = angular.isDate(scope.status.endTime) ? scope.status.endTime.getHours() : "";
                    var endMinute = angular.isDate(scope.status.endTime) ? scope.status.endTime.getMinutes() : "";
                    var endTime = angular.isDefined(endHour) ? handleNumber(endHour) + ":" + handleNumber(endMinute) : "";
                    if (angular.isDefined(startTime) && angular.isDefined(endTime)) {
                        scope.model = [startTime, endTime];
                    }
                }
            }
            /**
             * [initTemplate description] 初始化模板
             * @return {[type]} [description]
             */
            function initTemplate() {
                var deffer = $q.defer();
                $templateRequest("./utils/dateTimePicker/trsStartEndTime_tpl.html").then(function(template) {
                    scope.status.template = $compile(template)(scope);
                    scope.status.template.insertAfter($elem);
                    deffer.resolve();
                });
                return deffer.promise;
            }
            /**
             * [initBindHover description] 初始化聚焦和hover
             * @return {[type]} [description]
             */
            function initFocusHover() {
                $("body").bind("mouseover", hoverEvent);
                $("body").bind("click", clickEvent);
                scope.$on("$destroy", function() {
                    $("body").unbind("mouseover", hoverEvent);
                    $("body").unbind("click", clickEvent);
                });
            }

            function hoverEvent(e) {
                if ($(e.target).parents(".trsStartEndTime").length > 0) {
                    scope.status.template.css("border-color", "#39B88C");
                } else {
                    scope.status.template.css("border-color", "#f4f5f7");
                }
            }
            /**
             * [placeholderClick description] placeholder DIV点击事件
             * @return {[type]} [description]
             */
            scope.placeholderClick = function() {
                scope.status.template.find("input")[0].focus();
            };

            function clickEvent(e) {
                var flag = false;
                scope.status.template.find("input").each(function() {
                    if (this === e.target) {
                        flag = true;
                    }
                });
                if (flag) {
                    scope.status.template.css("border-color", "#39B88C");
                } else {
                    scope.status.template.css("border-color", "#f4f5f7");
                    /*if (timePickerIsShow() && !!scope.status.startTime && !!scope.status.endTime) {
                        $timeout(function() {
                            if (scope.status.startTime > scope.status.endTime) {
                                var tempTime = scope.status.startTime;
                                scope.status.startTime = scope.status.endTime;
                                scope.status.endTime = tempTime;
                            }
                            var startHour = angular.isDate(scope.status.startTime) ? scope.status.startTime.getHours() : "";
                            var startMinute = angular.isDate(scope.status.startTime) ? scope.status.startTime.getMinutes() : "";
                            var startTime = !!startHour ? handleNumber(startHour) + ":" + handleNumber(startMinute) : "";
                            var endHour = angular.isDate(scope.status.endTime) ? scope.status.endTime.getHours() : "";
                            var endMinute = angular.isDate(scope.status.endTime) ? scope.status.endTime.getMinutes() : "";
                            var endTime = !!endHour ? handleNumber(endHour) + ":" + handleNumber(endMinute) : "";
                            scope.model = [startTime, endTime];
                        });
                    }*/
                }
            }
            /**
             * [handleNumber description] 处理时间数据
             * @return {[type]} [description]
             */
            function handleNumber(number) {
                return isNaN(number) ? "" : number > 9 ? number + "" : "0" + number;
            }
            /**
             * [timePickerIsShow description] 时间控件是否显示
             * @return {[type]} [description]
             */
            function timePickerIsShow() {
                var flag = false;
                scope.status.template.find(".trsTimepicker").each(function() {
                    if ($(this).css("display") !== "none") {
                        flag = true;
                    }
                });
                return flag;
            }
            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                var startDateTime = new Date();
                var startTimeArray = angular.isArray(scope.model) && !!scope.model[0] ? scope.model[0].split(":") : [];
                var startHour = !!startTimeArray[0] ? startTimeArray[0] : "";
                var startMinute = !!startTimeArray[1] ? startTimeArray[1] : "";
                if (!!startHour) {
                    var date = new Date();
                    date.setHours(startHour);
                    date.setMinutes(startMinute);
                    scope.status.startTime = new Date(date);
                }
                var endTimeArray = angular.isArray(scope.model) && !!scope.model[1] ? scope.model[1].split(":") : [];
                var endHour = !!endTimeArray[0] ? endTimeArray[0] : "";
                var endMinute = !!endTimeArray[1] ? endTimeArray[1] : "";
                if (!!endHour) {
                    var date_ = new Date();
                    date_.setHours(endHour);
                    date_.setMinutes(endMinute);
                    scope.status.endTime = new Date(date_);
                }
                scope.$watch("model", function(newV, oldV) {
                    if (!oldV && !!newV) {
                        initData();
                    }
                });
            }
        }
    };
}]);